// extracted by mini-css-extract-plugin
module.exports = {"tag":"TagListItem_tag_agLG3","link":"TagListItem_link_xlLE1"};